import type { CurrentCart, LanguageIsoCode } from '@/graphql/graphql';
import { createContext, useContext } from 'react';

interface CartContextValue {
    cartItemsCount: number;
    isReady: boolean;
    refreshCartSummary: () => Promise<number>;
    addToCart: (programId: string, language: LanguageIsoCode, excludeEpisodeIds?: string[]) => Promise<CurrentCart>;
    removeFromCart: (programId: string, language: LanguageIsoCode) => Promise<CurrentCart | null>;
    updateCart: (
        programId: string,
        currentLanguage: LanguageIsoCode,
        newLanguage: LanguageIsoCode,
    ) => Promise<CurrentCart | null>;
}

export const CartContext = createContext<CartContextValue | null>(null);

export const useCart = (): CartContextValue => {
    const context = useContext(CartContext);
    if (!context) {
        throw new Error('useCart must be used within a CartProvider');
    }
    return context;
};
